interface Options {
  label: string;
  value: string;
  tooltip?: string;
  price?: string;
  subtitle?: string;
  disabled?: boolean;
}

interface SelectorSectionProps {
  options: Options[];
  title?: string;
  handleClick: (value: string) => void;
  iconFunc: (label: string, isSelected: boolean) => React.ReactElement;
  optionSelected: string;
}

const SelectorSection = (props: SelectorSectionProps) => {
  const { options, handleClick, iconFunc, optionSelected } = props;

  return (
    <div className="grid grid-cols-2 xl:grid-cols-3 gap-2 w-full">
      {options.map((option, index) => {
        const isSelected = option.value === optionSelected;
        const isDisabled = Boolean(option.disabled);

        return (
          <button
            key={`${option.label}-${index}`}
            type="button"
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) {
                handleClick(option.value);
              }
            }}
            className={`w-full px-3 py-2.5 rounded-xl normal-case flex items-center justify-start gap-2.5 border-2 transition-all ${
              isDisabled
                ? 'opacity-40 border-slate-200 bg-slate-50 text-slate-400 cursor-not-allowed grayscale'
                : isSelected
                  ? 'border-primary bg-primary/5 text-secondary font-bold shadow-xs cursor-pointer'
                  : 'border-divider text-text-secondary bg-white hover:bg-slate-50 hover:text-secondary cursor-pointer'
            }`}
          >
            <div className="shrink-0">{iconFunc(option.value, isSelected && !isDisabled)}</div>
            <div className="flex flex-col items-start text-left min-w-0 flex-1">
              <div className="flex items-center justify-between w-full gap-1">
                <span className="text-sm font-semibold truncate">{option.label}</span>
                {isDisabled && (
                  <span className="text-[9px] uppercase font-bold text-rose-500 bg-rose-50 px-1 py-0.5 rounded-xs shrink-0">
                    Sin cobertura
                  </span>
                )}
              </div>
              {option.price && !isDisabled && (
                <span
                  className={`text-xs font-bold ${isSelected ? 'text-primary' : 'text-slate-500'}`}
                >
                  {option.price}
                </span>
              )}
              {option.subtitle && !isDisabled && (
                <span className="text-[10px] text-slate-400 truncate w-full">
                  {option.subtitle}
                </span>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default SelectorSection;
